<div id="detailPageWrapper">
    <app-introduction-page-block [title]="'គ្មាន​ទិន្នន័យ'" [backgroundColor]="'radial-gradient( circle 732px at -23.9% -25.1%,  rgba(30,39,107,1) 6.1%, rgba(188,104,142,1) 100.2% )'"></app-introduction-page-block>
</div>